export type RndcContingencyEntityStatus = 'pending' | 'retransmitted' | 'none';

export interface RndcContingencyAlertConfig {
  shouldShow: boolean;
  alertClass: string;
  iconClass: string;
  title: string;
  description: string;
}

export const EMPTY_RNDC_CONTINGENCY_ALERT: RndcContingencyAlertConfig = {
  shouldShow: false,
  alertClass: '',
  iconClass: '',
  title: '',
  description: '',
};
